<template>
    <div class="content_box">
        <div class="content">
            <div class="top area_box">
                <div class="title">
                    <span>业绩报表</span>&nbsp;&nbsp;
                    <span class="end_time">截止至{{formDate(Date.now ())}}</span>
                </div>
                <div class="search_box">
                    <el-form class="form-list" label-position="left" label-width="90px">
                        <el-form-item label="统计时间">
                            <el-select v-model="searchData.year" placeholder="年份" style="width: 160px;">
                                <el-option v-for="(item, i) in (new Date()).getFullYear() - 2021" :key="item" :label="new Date().getFullYear() - i" :value="new Date().getFullYear() - i"></el-option>
                            </el-select>
                            <el-select v-model="searchData.quarterly" placeholder="季度" style="width: 160px;">
                                <el-option v-for="item in quarterList" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="统计维度">
                            <el-radio-group v-model="searchData.data_type" size="small">
                                <el-radio-button class="radio" label="team">按销售团队</el-radio-button>
                                <el-radio-button class="radio" label="mate">按业务人员</el-radio-button>
                                <el-radio-button class="radio" label="product">按产品型号</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="统计指标">
                            <el-radio-group v-model="searchData.statistics_type" size="small">
                                <el-radio-button class="radio" label="sale_amount">销售额</el-radio-button>
                                <el-radio-button class="radio" label="sale_num">销量</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="line"></div>
                <div class="type_box el_form">
                    <el-select v-model="searchData.select_key" style="width: 160px;" v-show="searchData.data_type != 'team'" clearable :placeholder="searchData.data_type == 'mate' ? '团队选择' : '业务人员选择'">
                        <el-option v-for="item in selectData" :key="item.id" :label="item.key || '未分类'" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="chart_box">
                    <div class="chart" ref="chart_dom"></div>
                </div>
            </div>
            <div class="area_box detail">
                <div class="title subtitle">
                    <span>数据明细</span>
                </div>
                <el-table
                    :data="trendTableData" ref="trendTable" highlight-current-row @sort-change="sortChange" :default-sort = "{prop: 'saleAmountRate', order: 'descending'}">
                    <el-table-column label="排名" type="index" :index="(page - 1) * page_size + 1" width="70">
                    </el-table-column>
                    <el-table-column :label="searchData.data_type == 'team' ? '销售团队' : (searchData.data_type == 'mate' ? '业务人员' : '产品型号')" >
                        <template slot-scope="scope">
                            <span>{{scope.row.productName || scope.row.key || '未分类'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleAmountRate" label="销售额目标完成率" sortable="custom" width="160">
                        <template slot-scope="scope">
                            <span>{{scope.row.saleAmountRate || '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售额目标">
                        <template slot-scope="scope">
                            <span>{{scope.row.tarSaleAmount ? formatNumber(scope.row.tarSaleAmount) : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleAmount" label="实际销售额" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{scope.row.saleAmount ? formatNumber(scope.row.saleAmount) : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleNumRate" label="销量目标完成率" sortable="custom" width="150">
                        <template slot-scope="scope">
                            <span>{{scope.row.saleNumRate || '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销量目标" >
                        <template slot-scope="scope">
                            <span>{{scope.row.tarSaleNum ? formatNumber(scope.row.tarSaleNum) : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleNum" label="实际销量" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{scope.row.saleNum ? formatNumber(scope.row.saleNum || 0) : '--'}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <Pagination :total="trendTable.length" :page="page" @paginationChange="initTableData"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import resize  from "../../../minxins/resize"
export default ({
    name: 'performance',
    mixins: [resize],
    data() {
        return {
            searchData: {
                year: (new Date()).getFullYear(),
                quarterly: '',
                data_type: 'team',
                statistics_type: 'sale_amount',
                select_key: ''
            },
            quarterList: ['Q1', 'Q2', 'Q3', 'Q4'],
            dictData: [],
            rootData: [],
            productType: [],
            selectData: [],
            trendTable: [],
            trendTableData: [],
            page: 1,
            page_size: 10
        }
    }, 
    computed: {
        searchDataNew() {
            return JSON.parse(JSON.stringify(this.searchData))  
        }
    },
    watch: {
        'searchDataNew': {
            handler (nD, oD) {
                if(nD.select_key && nD.select_key == oD.select_key) {
                    this.searchData.select_key = '';
                    return;
                }
                this.getTarget();
                if(nD.data_type != 'team'){
                    this.getTargetParam();
                }
            },
            deep: true
        },
        'searchData.year': {
            handler(nY) {
                let date = new Date();
                if(nY != date.getFullYear()) {
                    this.quarterList = ['Q1', 'Q2', 'Q3', 'Q4'];
                }else{
                    let month = date.getMonth() + 1;
                    switch (month) {
                        case 1:
                        case 2:
                        case 3:
                            this.quarterList = ['Q1']; break;
                        case 4:
                        case 5:
                        case 6:
                            this.quarterList = ['Q1', 'Q2']; break;
                        case 7:
                        case 8:
                        case 9:
                            if(nY == '2022') {
                                this.quarterList = ['Q3']; break;
                            }
                            this.quarterList = ['Q1', 'Q2', 'Q3']; break;
                        case 10:
                        case 11:
                        case 12:
                            if(nY == '2022') {
                                this.quarterList = ['Q3', 'Q4']; break;
                            }
                            this.quarterList = ['Q1', 'Q2', 'Q3', 'Q4']; break;
                    }
                }
                if(this.quarterList.indexOf(this.searchData.quarterly) == -1 ) {
                    this.searchData.quarterly = this.quarterList[this.quarterList.length - 1]; 
                }
            },
            immediate: true
        },
    },
    created() {
        this.getDictData();
    },
    methods: {
        getDictData() {
			this.api.getDictData({}).then(data => {
                this.productType = data.data.result_list || [];
            })
		},
        getTargetParam() {
            let searchData = {...this.searchData};
            searchData.year += ''; 
            this.api.getTargetParam(searchData).then(data => {
                this.selectData = data.data.result.filter(item => {
                    return item.id;
                })
            })
        },
        getTarget() {
            let searchData = {...this.searchData};
            searchData.year += ''; 
            this.api.getTarget(searchData).then(data => {
                this.rootData = data.data.result;
                if(this.searchData.data_type == 'product') { //产品数据加上name
                    this.rootData.forEach((rItem, i) => {
                        this.productType.forEach(pItem => {
                            if(pItem.id == rItem.key) {
                                this.rootData[i].productName = pItem.dictItem;
                            }else if(rItem.key === '') {
                                this.rootData[i].productName = '未分类';
                            }
                        })
                    })
                }
                this.rootData.sort((a,b) => {
                    return b.saleAmountRate.split('%')[0] - a.saleAmountRate.split('%')[0];
                })
                this.trendTable = [...this.rootData];
                this.$nextTick(() => {
                    this.initBar();
                })
                this.initTableData({page_size: this.page_size, page: 1});
            })
        },
        initTableData(data, sort) {
            this.trendTableData = [];
            this.page = data.page;
            this.page_size = data.page_size;
            for(let i=(data.page_size * (data.page - 1)); i<this.trendTable.length; i++) {
                this.trendTableData.push(this.trendTable[i]);
                if(this.trendTableData.length == data.page_size) break;
            }
        },
        sortChange(sort) {
            if(sort.order == 'descending') { //降序
                this.trendTable.sort((a,b) => {
                    if(sort.prop == 'saleAmountRate' || sort.prop == 'saleNumRate') {
                        return parseFloat((b[sort.prop] || '-1%').split('%')) - parseFloat((a[sort.prop] || '-1%').split('%'));
                    }else{
                        return parseFloat(b[sort.prop] || 0) - parseFloat(a[sort.prop] || 0);
                    }
                })
            }else if(sort.order == 'ascending'){
                this.trendTable.sort((a,b) => {
                    if(sort.prop == 'saleAmountRate' || sort.prop == 'saleNumRate') {
                        return parseFloat((a[sort.prop] || '-1%').split('%')) - parseFloat((b[sort.prop] || '-1%').split('%'));
                    }else{
                        return parseFloat(a[sort.prop] || 0) - parseFloat(b[sort.prop] || 0);
                    }
                })
            }else{
                this.trendTable = [...this.rootData];
            }
            this.initTableData({page_size: this.page_size, page: this.page}, this.$refs.trendTable.sort(sort));
        },
        initEcharts() {
            var chartDom = this.echarts.init(this.$refs.chart_dom);
            chartDom.resize();
        },
        initBar() {
            let label = [], value1 = [], value2 = [];
            this.rootData.forEach(item => {
                label.push(item.productName || item.key || '未分类');
                if(this.searchData.statistics_type == 'sale_amount') {
                    value1.push(item.tarSaleAmount);
                    value2.push(item.saleAmount);
                }else {
                    value1.push(item.tarSaleNum);
                    value2.push(item.saleNum);
                }
            })
            var chartDom = this.echarts.init(this.$refs.chart_dom);
			chartDom.clear();
        	chartDom.setOption(this.setBarOption(label, value1, value2));
        },
        setBarOption(label, value1, value2) {
			return {
				color: ['#21E1FF', 'rgba(80, 127, 247, 1)'],
				grid: {
					left: '36',
					right: '1',
					top: '40',
					bottom: '50',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
                    formatter: (p) => {
                        let str = `${p[0].name}<br /> ${p[0].marker + p[0].seriesName}: ${p[0].value ? this.formatNumber(p[0].value) : '--'}<br /> ${p[1].marker +p[1].seriesName}: ${p[1].value ? this.formatNumber(p[1].value) : '--'} <br />  <span style="padding-left: 14px;">目标完成率: <span/>`;
                        if(this.searchData.statistics_type == 'sale_amount') {
                            str += this.rootData[p[0].dataIndex].saleAmountRate || '--';
                        }else{
                            str += this.rootData[p[0].dataIndex].saleNumRate || '--';
                        }
                        return str;
                    }
				},
				legend: {
                    bottom: 0,
                    left: 'center',
					itemGap: 40,
                    itemWidth: 12,
					itemHeight: 12,
					textStyle: {
						color: '#999',
					},
					selectedMode: false,
					data: this.searchData.statistics_type == 'sale_amount' ? ['目标销售额', '实际销售额'] : ['目标销量', '实际销量']
				},
				xAxis: [
					{
					type: 'category',
					axisTick: {
						show: false
					},
                    axisLine: {
						show: false,
					},
					splitLine: {
						show: false
					},
                    axisLabel: {
                        rotate: this.searchData.data_type == 'product' ? 30 : 0,
                    },
					data: label
					}
				],
				yAxis: {
					type: 'value',
					name: this.searchData.statistics_type == 'sale_amount' ? '销售额' : '销量',
					alignTicks: true,
					nameTextStyle: {
						align: 'right',
                        lineHeight: 30
					},
					axisLine: {
						show: false,
					},
					axisLabel: {
						formatter: function(value, index) {
                            if(value/1000000 >= 1) {
                                return value/1000000 + 'M';
                            }else if(value/1000 >= 1) {
                               return value/1000 + 'K';
                            }
                            return value;
                        }
					},
					axisTick: {
						show: false
					},
					splitLine: {
						lineStyle: {
                            color: '#E8E9F1',
                            type: 'dashed'
                        }
					}
				},
				series: [{
					name: this.searchData.statistics_type == 'sale_amount' ? '目标销售额' : '目标销量',
					type: 'bar',
					yAxisIndex: 0,
                    z: 0,
					barWidth: 20,
					data: value1
				},{
					name: this.searchData.statistics_type == 'sale_amount' ? '实际销售额' : '实际销量',
					type: 'bar',
                    barGap: '-100%',
					yAxisIndex: 0,
                    z: 1,
					barWidth: 20,
					data: value2
				}]
			};
		}
    }
})
</script>     

<style lang="less" scoped>
    .content{
        padding: 0;
        background: none;
        .area_box{
            padding: @padding;
            background: #fff;
            border-radius: 12px;
            margin-bottom: 20px;
        }
        .top{
            .title{
                margin-bottom: 40px;
                .end_time{
                    font-size: 12px;
                    color: #999999;
                    font-weight: normal;
                }
            }
            /deep/.search_box{
                .el-form-item__label{
                    color: @color999;
                }
                .el-radio-button{
                    margin-right: 12px;
                    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                        box-shadow: none;
                    }
                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background-color: @colorBlue2;
                        color: @colorWhite;
                    }
                    .el-radio-button__inner {
                        border: 1px solid @colorLine;
                        border-radius: unset;
                        width: 100px;
                        color: @colorGray;
                        border-radius: 4px;
                    }
                }   
            }
            .type_box{
                text-align: right;
                /deep/.el-input__inner{
                    width: 100%;
                    min-width: 0;
                }
            }
            .chart_box{
                width: 100%;
                height: 350px;
                .chart{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .detail{
            .title{
                color: @colorBlue2;
            }
        }
    }


</style>


// WEBPACK FOOTER //
// src/view/statistics/sales/performance.vue